import { render, staticRenderFns } from "./plan2029.vue?vue&type=template&id=4a32d334&scoped=true"
import script from "./plan2029.vue?vue&type=script&lang=js"
export * from "./plan2029.vue?vue&type=script&lang=js"
import style0 from "./plan2029.vue?vue&type=style&index=0&id=4a32d334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32d334",
  null
  
)

export default component.exports